export default __webpack_public_path__ + "static/media/Scooter.907c7bcf.png";